import { createSlice } from '@reduxjs/toolkit';

//const initialState = false;
const initialState = localStorage.getItem('mode')
  ? JSON.parse(localStorage.getItem('mode'))
  : {
    showStages: true,
    theme: 'light',
    sortByType: true,
    showCreatedAt: false,
    financingMarkerMode: 'inline',
    showMortgageUnderline: false,
    viewInvisible: false,
    currentType: '',
    currentKind: '',
    currentSort: { id: 'createdAt', title: 'По дате' },
    searchString: '',
  };

const modeSlice = createSlice({
  name: 'mode',
  initialState,
  reducers: {
    setVisibilityStages: (state, action) => {
      const newStage = {
        ...state,
        showStages: action.payload,
      };
      localStorage.setItem('mode', JSON.stringify(newStage));
      return newStage;
    },
    setSortByType: (state, action) => {
      const newStage = {
        ...state,
        sortByType: action.payload,
      };
      localStorage.setItem('mode', JSON.stringify(newStage));
      return newStage;
    },
    setShowCreatedAt: (state, action) => {
      const newStage = {
        ...state,
        showCreatedAt: action.payload,
      };
      localStorage.setItem('mode', JSON.stringify(newStage));
      return newStage;
    },
    setFinancingMarkerMode: (state, action) => {
      const nextState = {
        ...state,
        financingMarkerMode: action.payload === 'badge' ? 'badge' : 'inline',
      };
      localStorage.setItem('mode', JSON.stringify(nextState));
      return nextState;
    },
    setShowMortgageUnderline: (state, action) => {
      const nextState = { ...state, showMortgageUnderline: action.payload === true };
      localStorage.setItem('mode', JSON.stringify(nextState));
      return nextState;
    },
    setTheme: (state, action) => {
      const newStage = {
        ...state,
        theme: action.payload,
      };
      localStorage.setItem('mode', JSON.stringify(newStage));
      return newStage;
    },
    setSearchString: (state, action) => {
      const newStage = {
        ...state,
        searchString: action.payload,
      };
      return newStage;
    },
    setViewInvisible: (state, action) => {
      const newStage = {
        ...state,
        viewInvisible: action.payload,
      };
      localStorage.setItem('mode', JSON.stringify(newStage));
      return newStage;
    },
    setCurrentType: (state, action) => {
      const newState = {
        ...state,
        currentType: action.payload,
      };
      //localStorage.setItem('mode', JSON.stringify(newState));
      return newState;
    },
    setCurrentSort: (state, action) => {
      const newState = {
        ...state,
        currentSort: action.payload,
      };
      localStorage.setItem('mode', JSON.stringify(newState));
      return newState;
    },
    setCurrentKind: (state, action) => {
      const newState = {
        ...state,
        currentKind: action.payload,
      };
      localStorage.setItem('mode', JSON.stringify(newState));
      return newState;
    },
  },
});

export const {
  setSearchString,
  setShowCreatedAt,
  setFinancingMarkerMode,
  setShowMortgageUnderline,
  setCurrentSort,
  setCurrentType,
  setVisibilityStages,
  setTheme,
  setSortByType,
  setViewInvisible,
  setCurrentKind
} = modeSlice.actions;
export default modeSlice.reducer;
